<template>
  <div class="xscontainer jsjiesh">
    <div class="ncltwew">
      <div class="zjjsc322">行业专家</div>
      <div class="zjlist">
        <div class="jies" v-for="(col, pindex) in jiangshilist">
          <img class="txys" src="@/assets/xxkc/22_1@4x.png" alt="企业数据治理联盟">
          <div class="rightcss">
            <p class="rm">{{col.zjname}}</p>
            <p class="jisha">{{col.zjjs}}</p>
          </div>
        </div>
        <Fenye @parentToRefresh="refresh" :parentPageNo="currentPageNo" :pages="pages" :total="total"></Fenye>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jiangshilist:[],
      currentPageNo:0,
      curentPageSize:3,
      pages:0,
      total:0,
      fields: 'id,,,zjname,jianjie,zjjs,zjtxString,action',
      fwcishu:0
    };
  },
  mounted() {
    this.refresh();
  },
  created() {
    this.tongji('行业专家');
  },
  methods:{
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    refresh (pageNo) {
      this.currentPageNo = pageNo;
      if(!this.currentPageNo){
        this.currentPageNo = 0;
      }
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/zhuanjia/tZhuanjia/list?_t='+new Date().getTime()+'&column=pxh&order=asc&field='+this.fields+'&pageNo='+this.currentPageNo+'&pageSize='+this.curentPageSize)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.jiangshilist = response.data.result.records;
              that.pages = response.data.result.pages;
              that.total = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });

    },
  }
};
</script>

<style scoped>
.ncltwew{
  display: flex;
  flex-direction: column;
  gap:3rem;
}
.zjjsc322{
  display: flex;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;

}
.zjlist{
  display: flex;
  flex-direction: column;
  gap:3rem;
}
.jies{
  min-width: 50rem;
  min-height: 9rem;
  background-color: #f2f9ff;
  border-radius: 9rem 0 0 9rem ;

  display: flex;
  justify-content: start;
  align-items: center;
  gap:2rem;
}
.txys{
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  margin-left: 2rem;
}
.rightcss{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-right: 2rem;
}
.rm{
  font-size: 1.3rem;
  font-weight: bold;
}
.jisha{
  color: #7e7c7c;
}

</style>
